// extracted by mini-css-extract-plugin
module.exports = {"main":"Hero-module--main--Tn3z2","heroPresentation":"Hero-module--heroPresentation--3m3it","form":"Hero-module--form--Vljax"};